<template>
  <div :class="[_class, 'header-cls']">
    <div :class="_containerClass">
      <div :class="_leftClass">
        <a :class="_titleClass" :style="_titleStyle" :href="titleHref" title="点击访问广东政务服务网">
          <h1>{{title}}</h1>
        </a>
        <!-- <slot name="subtitle">
          <a v-if="accountType" :class="_subtitleClass" :href="subtitleHref">
            <h2>{{subtitle}}{{accountType==1?"（个人）":"（法人）"}}</h2>
          </a>
        </slot> -->
      </div>
      <div :class="_rightClass">
        <button type="button" class="btn-no-style red-btn-cls" @click="slh" v-if="isSlhAndWza">长者助手</button>
        <button type="button" class="btn-no-style txt-btn-cls" @click="wza" id="wza" v-if="isSlhAndWza">无障碍阅读</button>
        <template v-if="this.$store.state.login">
          <el-dropdown trigger="click" class="md-userinfo-drop" @command="selectCommand">
            <span class="el-dropdown-link">
              {{sensitiveField(userName)}}
              <i class="el-icon-caret-bottom"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="logout"><span class="user-status-cls">退出登陆</span></el-dropdown-item>
              <el-dropdown-item command="myAppointMent"><span class="user-status-cls">我的预约</span></el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </div>
    </div>
    <iframe src id="tyrzLogoutFrame" width="0" height="0" style="display:none;"></iframe>
  </div>
</template>
<script>
const name = "md-biz-header";
const mhHost = "www.gdzwfw.gov.cn";
import { getCookie } from "@/utils/utils.js"; // 引入接口
import { sensitiveField } from '@/utils/sensitiveUtil.js'
import {
  interOutUserInfo,
} from "@/utils/appointment.url.js";
import { Base64 } from "js-base64";
export default {
  name,
  components: {},
  props: {
    type: String,

    title: {
      type: String,
      default: "广东省政务服务网",
    },
    titleHref: {
      type: String,
      default: `http://www.gdzwfw.gov.cn`,
    },

    subtitle: String,
    subtitleHref: String,

    userinfoDropProps: Object,
    userinfoDropHidden: Boolean,
    isSlhAndWza: Boolean,
    navData: {
      type: Array,
      default () {
        return [{
            text: "首页",
            href: `//${mhHost}/portal/index`,
          },
          {
            text: "个人服务",
            href: `//${mhHost}/portal/personal/hot`,
          },
          {
            text: "法人服务",
            href: `//${mhHost}/portal/legal/hot`,
          },
          {
            text: "政务公开",
            href: `//${mhHost}/portal/affairs-public-index`,
          },
          {
            text: "政民互动",
            href: `//${mhHost}/portal/gov-people-interact`,
          },
          {
            text: "效能监督",
            href: `//${mhHost}/xnjd/index?region=440000`,
          },
          {
            text: "便民利企",
            href: `//${mhHost}/portal/convenience-people-enterprise`,
          },
        ];
      },
    },

    searchHidden: Boolean,
    searchValue: String,
  },
  data() {
    return {
      curSearchValue: this.searchValue,
      userName: "",
      accountType: "",
    };
  },
  computed: {
    _class() {
      return [name];
    },
    _containerClass() {
      return [`${name}-container`];
    },
    _leftClass() {
      return [`${name}-left`];
    },
    _rightClass() {
      return [`${name}-right`];
    },
    _titleClass() {
      return [`${name}-title`];
    },
    _titleStyle() {
      return {
        backgroundImage: this.logo && `url(${this.logo})`,
      };
    },
    _subtitleClass() {
      return [`${name}-subtitle`];
    },
    _navClass() {
      return [`${name}-nav`];
    },
    _searchClass() {
      return [`${name}-search`];
    },
  },
  watch: {
    searchValue(value) {
      this.curSearchValue = value;
    },
  },

  methods: {
    sensitiveField,
    // 增加老年模式
    slh() {
      //eslint-disable-next-line
      slhInstance.init(); // slhInstance 为全局变量 
    },
    // 无障碍
    wza() {
      //eslint-disable-next-line
      cnillWzaInstance.init(); // cnillWzaInstance为全局变量
    },
    getActive(item) {
      const { href } = item;
      const { pathname } = location;
      return href.indexOf(pathname) !== -1;
    },

    onSearch() {
      this.$emit("headersearch", this.curSearchValue);
    },
    clearAllCookie() {
      var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
      if (keys) {
        for (var i = keys.length; i--;) {
          document.cookie =
            keys[i] + "=0;path=/;expires=" + new Date(0).toUTCString(); //清除当前域名下的,例如：m.kevis.com
          document.cookie =
            keys[i] +
            "=0;path=/;domain=" +
            document.domain +
            ";expires=" +
            new Date(0).toUTCString(); //清除当前域名下的，例如 .m.kevis.com
          document.cookie =
            keys[i] +
            "=0;path=/;domain=kevis.com;expires=" +
            new Date(0).toUTCString(); //清除一级域名下的或指定的，例如 .kevis.com
        }
      }
    },
    selectCommand(command) {
      if (command == "logout") {
        let auth_logout_url = sessionStorage.getItem("auth_logout_url");
        let redirect_logout_url = sessionStorage.getItem("redirect_logout_url");
        let rURL = Base64.btoa(
          `${location.protocol}//${location.host}${process.env.BASE_URL}entering.html?logout=true`
        );
        let redirect_uri = encodeURIComponent(
          redirect_logout_url + "?rURL=" + rURL
        );
        console.log(`${auth_logout_url}?redirect_uri=${redirect_uri}`);
        this.clearAllCookie(); //清除cookie
        sessionStorage.clear(); //清除sessionStorage
        // 对接新的退出登录--白云 （公司测试不了 没有申请到资源）
        window.location.href = `${auth_logout_url}?redirect_uri=${redirect_uri}`;
      }
      if (command == 'myAppointMent') {
        this.$router.push({
          path: '/myAppointMent'
        })
      }
    },
    getUserInfo() {
      interOutUserInfo({
        //0、获取用户信息接口
        loginaware: true, // 正式环境使用loginaware
      }, "get").then((resUserInfo) => {
        console.log(resUserInfo);
        this.userName = resUserInfo.data.userInfo.name;
        sessionStorage.setItem("userCode", resUserInfo.data.userInfo.userCode);
        sessionStorage.setItem("uType", resUserInfo.data.userInfo.uType);
      });
    },
  },
  created() {
    if (getCookie("access-token")) {

      this.getUserInfo();
    }
  },
  mounted() {
    cnillWzaInstance.setOption({
      domId: '#wza'
    })
  },
};
</script>
<style lang="scss">
// 背景色
$bg-color: #fff;
$bg-color1: #bec0c3;
$bg-color2: #e2e2e2;
$bg-color3: #f1f2f3;
// 布局
$container-width: 1200px;
// 正文色
$text-color: #112534;
$text-color-light: #152e48;
// 二级文字色
$text-color2: #444;
// 三级文字色
$text-color3: #777;
// 边框色
$border-color: #c4c4c4;
// 主题色
$primary-color: #3e97df;
// 链接hover色
$link-hover-color: #0066b9;
// 动画时长
$animation-duration: 0.2s;

.md-biz-header {
  .el-dropdown-link {
    cursor: pointer;
  }

  background: #fff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15);
  position: relative;
  z-index: 1;
  min-width: $container-width;

  &-container {
    position: relative;
    width: 1200px;
    margin-left: auto;
    margin-right: auto;
    zoom: 1;

    &:after {
      content: "";
      clear: both;
      display: table;
    }
  }

  &-left {
    padding: 20px 0;
    position: absolute;
    left: 0px;

    &:after {
      content: "";
      clear: both;
      display: table;
    }

    &>a {
      line-height: 40px;
      float: left;
      cursor: inherit;
      color: inherit;

      &[href] {
        cursor: pointer;
      }
    }
  }

  &-title {
    h1 {
      font-size: 22px;
      padding-left: 44px;
      background: url(../../assets/img/layout/logo.png) left center no-repeat;
      background-size: 32px 32px;
      font-weight: bold;
    }

    &:not(:last-child) {
      padding-right: 15px;
      margin-right: 15px;
      position: relative;

      &:after {
        content: "";
        position: absolute;
        top: 11px;
        bottom: 11px;
        right: 0;
        width: 1px;
        background: $border-color;
      }
    }
  }

  &-subtitle {
    h2 {
      font-size: 18px;
      font-weight: bold;
    }
  }

  &-right {
    // float: right;
    position: absolute;
    left: auto;
    right: 0px;
  }

  //用户下拉选择
  .md-userinfo-drop {
    margin-top: 29px;
    font-size: 16px;
    .el-icon-arrow-down {
      cursor: pointer;
    }
  }

  &-nav {
    a {
      display: inline-block;
      height: 40px;
      font-size: 16px;
      line-height: 20px;
      color: inherit;
      padding-top: 4px;

      &:not(:last-child) {
        margin-right: 60px;
      }

      &.active {
        color: $primary-color;
        box-shadow: 0 -4px 0 0 $primary-color inset;
      }

      &:hover {
        color: $link-hover-color;
      }
    }
  }

  &-search {
    float: right;

    .gd-input {
      margin-top: -4px;
      width: auto;
      font-size: 13px;

      input {
        width: 185px;
        background: #f1f2f3;
        border-color: #f1f2f3;
        transition: all $animation-duration;

        &:focus {
          width: 270px;
          border-color: $primary-color;
          background: #fff;
        }
      }
    }

    .gd-icon {
      font-size: 16px;
      padding-right: 6px;
    }
  }
}

.header-cls {
  height: 80px;

  .red-btn-cls {
    background: #C31C1F;
    border-radius: 17px;
    padding: 5px 10px;
    color: #fff;
    font-size: 18px;
    font-weight: 500;
    line-height: 25px;
    margin-right: 30px;
    margin-top: 22px;
  }

  .txt-btn-cls {
    font-size: 18px;
    color: #333333;
    line-height: 25px;
    margin-right: 40px;
    margin-top: 22px;
  }
}
.user-status-cls{
  font-size: 16px;
}
</style>